import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      await register(email, pwd, name);
      toast.success("Welcome to 2B FUNK!");
      nav("/profile");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="container-x py-20 max-w-md">
      <div className="eyebrow mb-4">// Join The Groove</div>
      <h1 className="section-heading mb-8">Sign Up</h1>
      <form onSubmit={submit} className="space-y-4 bg-[#121217] border border-white/10 p-8">
        <div>
          <label className="block text-[10px] font-mono-plex uppercase tracking-widest text-white/50 mb-2">Name</label>
          <input required value={name} onChange={(e) => setName(e.target.value)}
            className="w-full bg-black border border-white/10 px-4 py-3 focus:outline-none focus:border-[#FF5E00]"
            data-testid="register-name-input" />
        </div>
        <div>
          <label className="block text-[10px] font-mono-plex uppercase tracking-widest text-white/50 mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-black border border-white/10 px-4 py-3 focus:outline-none focus:border-[#FF5E00]"
            data-testid="register-email-input" />
        </div>
        <div>
          <label className="block text-[10px] font-mono-plex uppercase tracking-widest text-white/50 mb-2">Password</label>
          <input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)}
            className="w-full bg-black border border-white/10 px-4 py-3 focus:outline-none focus:border-[#FF5E00]"
            data-testid="register-password-input" />
        </div>
        <button disabled={loading} className="btn-primary w-full" data-testid="register-submit-btn">
          {loading ? "Creating..." : "Create Account"}
        </button>
        <div className="text-xs text-white/50 text-center font-mono-plex">
          Already registered? <Link to="/login" className="text-[#B3FF00] hover:underline">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
